import { fetchData } from '@/utils/fetch'

const currencyList = ref(null)

export const useCurrency = () => {
  const currentCurrency = computed(() => {
    if (currencyList.value == null) return null
    const storageCurrencyData = localStorage.getItem('currencyData')
    if (storageCurrencyData) {
      const storageCurrencyDataObj = JSON.parse(storageCurrencyData)
      return currencyList.value.find(
        (item) => item.targetCurrency === storageCurrencyDataObj.targetCurrency
      )
    } else {
      return currencyList.value[0]
    }
  })

  onBeforeMount(() => {
    getCurrency()
  })

  const getCurrency = async () => {
    if (currencyList.value == null) {
      await initCurrency()
    }
    return currencyList.value
  }

  const initCurrency = async () => {
    const { code, data } = await fetchData(
      '/dsp-app/alibaba-common/currencyList'
    )
    if (code === 200) {
      currencyList.value = data
    }
  }

  /**
   * 货币金额转换函数
   * @param {number} amount - 要转换的金额
   * @param {string} from - 来源货币代码（如 "CNY"）
   * @param {string} to - 目标货币代码（如 "USD"）
   * @returns {number} 转换后的金额
   */
  function exchangeCurrency (amount, from, to) {
    const list = currencyList.value
    if (from === to || list == null) return amount

    const rate = exchangeRate(from, to)

    return amount * rate
  }

  /**
   * 汇率计算函数，1 from = {return} to
   * @param {*} from 来源货币代码（如
   * @param {*} to 目标货币代码
   * @returns {number} 计算后的汇率
   */
  function exchangeRate (from, to) {
    const list = currencyList.value
    if (list == null) return null
    if (from === to) return 1

    const supportCurrencies = ['CNY', ...list.map(item => item.targetCurrency)]
    if (!supportCurrencies.includes(from) || !supportCurrencies.includes(to)) throw new Error(`不支持的货币类型: from: ${from} to: ${to}`)

    const directRate = list.find(item => item.fromCurrency === from && item.targetCurrency === to)?.rate

    if (directRate) return directRate

    const reverseRate = list.find(item => item.fromCurrency === to && item.targetCurrency === from)?.rate

    if (reverseRate) return 1 / reverseRate
    return exchangeRate(from, 'CNY') * exchangeRate('CNY', to)
  }

  return { getCurrency, currencyList, currentCurrency, exchangeCurrency, exchangeRate }
}
